import { DataTypes } from "@lexriver/data-types"

export enum EnumProductSort{
    Article = 'sku', 
    Date = 'date',
    Name = 'name',
    Price = 'price',
    OrderId = 'orderId',
    CustomOrderId = 'customOrderId'
}

export function convertStringToEnumProductSort(x:string|undefined, defaultValue:EnumProductSort){
    if(DataTypes.isValueExistsInEnum(x, EnumProductSort)){
        return x as EnumProductSort
    }
    return defaultValue
}

// export function getDislayNameByEnumProductSort(sort:EnumProductSort){
//     switch(sort){
//         case EnumProductSort.Article: return 'по артикулу'
//         case EnumProductSort.Date: return 'по дате'
//         case EnumProductSort.Name: return 'по названию'
//         case EnumProductSort.Price: return 'по цене'
//         case EnumProductSort.OrderId: return 'по OrderId'
//         case EnumProductSort.CustomOrderId: return 'вручную'
//     }
//     //return 'unknown'
// }